import styled from 'styled-components'

export const TabContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 0px 10px;
  margin-bottom: 0px;
  gap: 10px;
`

export const TabButton = styled.button`
  color: ${({ selected }) => selected ? '#000000' : '#252525'};
  background: ${({ selected }) => selected 
    ? 'linear-gradient(to right, #FFC100, #FF9800)' 
    : '#FFFFFF'
  };
  font-size: 14px;
  font-weight: 500;
  min-width: auto;
  width: ${({ width }) => width + 'px'};
  height: 38px;
  margin: 0px;
  border: 0px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 15px;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
  transition: opacity 0.2s;

  &:hover {
    opacity: ${({ disabled }) => disabled ? 0.5 : 0.7};
  }
`
